import { ApiCore } from '@polyu-dip/api-core'

export const getServerStatus = async (apiCore?: ApiCore) =>
  (apiCore ?? ApiCore.primary).get('/health')
